import { SearchCustomerInput } from 'gql/__generated/vp-apollo';
import { useForm, useFormContext } from 'react-hook-form';
import yup from '@cobra/validation/yup-extended';
import { landlineAreaCodeSchema, landlineCliSchema, telekomKdnrSchema } from '@cobra/validation/schemas';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSubmissionLock } from 'hooks/form/useSubmissionLock';

const customerSearchFormSchema = yup.object({
    customerNumber: telekomKdnrSchema.trim().required(),
    phone: yup.object({
        areaCode: landlineAreaCodeSchema.required(),
        cli: landlineCliSchema.required(),
    }),
});

export const useCustomerSearchForm = () =>
    useForm<SearchCustomerInput>({
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
        resolver: yupResolver(customerSearchFormSchema),
    });

export const useCustomerSearchFormContext = () => {
    const { handleSubmit, formState } = useFormContext<SearchCustomerInput>();
    const lockSubmission = useSubmissionLock(formState);

    return {
        handleSubmit,
        lockSubmission,
    };
};
